import { render } from "./EnableVGpuDevice.vue?vue&type=template&id=3b19997e&scoped=true"
import script from "./EnableVGpuDevice.vue?vue&type=script&lang=js"
export * from "./EnableVGpuDevice.vue?vue&type=script&lang=js"

import "./EnableVGpuDevice.vue?vue&type=style&index=0&id=3b19997e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b19997e"]])

export default __exports__